import * as e from "react";
const d = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BO_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#BO_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BO_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#BO_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v8h32V0H0z",
      fill: "#DB501C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 16v8h32v-8H0z",
      fill: "#5EAA22"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.445 9.96l.037-.036 7.22 6.945-.037.035-7.22-6.945z",
      fill: "#864C26"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.221 16.418l-.03.04-8.4-6.17.031-.04 8.4 6.17z",
      fill: "#864C26"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.398 15.801l-.026.044-9.343-5.086.026-.043 9.343 5.085z",
      fill: "#A05A2C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.602 9.112l.707.468-.04.028.05.03c.02.012.035.028.043.046a.274.274 0 000-.157l-.038-.149.084.13c.133.208.153.357.05.441-.102.082-.261.06-.476-.058l-.088-.048.1.002a.617.617 0 00.21-.03l-.041-.01c-.035-.01-.06-.034-.078-.072l-.069.047-.414-.668zm-.848.53l.778.338-.036.034.057.022c.021.008.038.02.049.036a.275.275 0 00-.029-.152l-.062-.14.105.114c.168.181.213.324.125.425-.085.098-.246.105-.479.025l-.094-.032.099-.015a.617.617 0 00.203-.066l-.042-.003c-.036-.003-.066-.024-.09-.059l-.06.058-.524-.585zm.05.812l-.804-.27.573.539.055-.064c.027.033.059.05.095.05h.044a.616.616 0 01-.197.084l-.097.024.097.024c.238.059.398.038.474-.067.079-.108.021-.247-.161-.413l-.115-.104.074.134c.03.055.044.105.042.15a.106.106 0 00-.053-.033 1.657 1.657 0 00-.059-.017l.033-.037zm-.088.023l-.515-.172.367.344.031-.035a.408.408 0 01-.015-.034l.003-.001-.024-.027.098-.085.013.002a.946.946 0 01.042.008z",
      fill: "#E7E7E7"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.47 16.213l.835-1.488 1.171.315-.842 1.359h-.329v.148l-.834-.334z",
      fill: "#925229"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.113 10.49l-.553.573-.2 3.795 1.99.29s-.867-.762-.995-1.232-.169-2.225.073-2.492l.189.11.152-.45",
      fill: "#FFE000"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.189 10.747s-.214 2.963-.214 3.483.441 1.76 1.448 1.76 2.39-.555 2.39-.78c0-.227-.413-.389-.413-.389s-1.852.127-1.852-.59c0-.718.126-2.842.235-3.092.11-.25.491-.628.491-.628l-.726-.54-.125.54-.466-.159-.142.787-.626-.392z",
      fill: "#D52C1E"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.777 11.076l-.134.42-.27-.115s-.405 1.896 0 2.69c.404.795 1.422.853 1.422.853l-.43-3.429-.588-.419z",
      fill: "#027934"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.717 13.639l-.97.767s-.267.382 0 .67c.265.29 1.004.584 1.178.235.174-.348.69-.757.69-.757l-.898-.915z",
      fill: "#E8A30C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.479 10.743c.236-.205.354-.456.264-.56-.09-.103-.355-.02-.59.185-.237.205-.355.455-.265.559.09.104.354.021.59-.184z",
      fill: "#E1E5E8"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.882 9.304s-.095-.02-.138-.026c-.307-.047-.46.016-.46.187 0 .294.195.611.195.833 0 .222.01.567.104.394.094-.172.572-.691.572-.691l-.273-.45s.678.076.38-.086M15.97 15.378l-.509-.005c-.378.374-.412.877-.115 1.484 0 0 .098.141.132.128.048-.018.114-.223.114-.223-.022-.593.356-.986.378-1.384z",
      fill: "#D52C1E"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.326 15.394l.183-.085c.18.374.09.763-.258 1.148l-.151-.132c.151-.442.151-.625.226-.931z",
      fill: "#FFE000"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.092 15.382l.191-.056c.092.314.046.638-.134.966l-.174-.095c.156-.284.194-.554.117-.815z",
      fill: "#027934"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.555 9.96l-.037-.036-7.22 6.945.037.035 7.22-6.945z",
      fill: "#864C26"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.779 16.418l.03.04 8.4-6.17-.031-.04-8.4 6.17z",
      fill: "#864C26"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M11.602 15.801l.026.044 9.343-5.086-.026-.043-9.343 5.085z",
      fill: "#A05A2C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.398 9.112l-.707.468.04.028a1.77 1.77 0 00-.05.03.107.107 0 00-.043.046.274.274 0 010-.157l.038-.149-.084.13c-.133.208-.153.357-.05.441.102.082.261.06.476-.058l.088-.048-.1.002a.617.617 0 01-.21-.03l.041-.01c.035-.01.06-.034.078-.072l.069.047.414-.668zm.848.53l-.778.338.035.034a1.95 1.95 0 00-.056.022.108.108 0 00-.049.036.275.275 0 01.029-.152l.062-.14-.105.114c-.168.181-.213.324-.125.425.085.098.246.105.479.025l.094-.032-.099-.015a.617.617 0 01-.203-.066l.042-.003c.036-.003.066-.024.09-.059l.06.058.524-.585zm-.05.812l.804-.27-.573.539-.055-.064c-.027.033-.059.05-.095.05h-.044a.616.616 0 00.197.084l.097.024-.097.024c-.238.059-.398.038-.474-.067-.079-.108-.021-.247.161-.413l.115-.104-.074.134a.274.274 0 00-.042.15.106.106 0 01.053-.033l.059-.017-.033-.037zm.088.023l.515-.172-.367.344-.031-.035a.408.408 0 00.015-.034l-.003-.001.024-.027-.098-.085-.012.002a.946.946 0 00-.043.008z",
      fill: "#E7E7E7"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.53 16.213l-.835-1.488-1.171.315.842 1.359h.329v.148l.834-.334z",
      fill: "#925229"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.887 10.488l.553.575.2 3.794-1.99.29s.867-.762.995-1.232.169-2.225-.073-2.492l-.189.11-.152-.45",
      fill: "#FFE000"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.811 10.747s.214 2.963.214 3.483-.441 1.76-1.448 1.76-2.39-.555-2.39-.78c0-.227.413-.389.413-.389s1.852.127 1.852-.59c0-.718-.126-2.842-.235-3.092-.11-.25-.491-.628-.491-.628l.726-.54.125.54.466-.159.142.787.626-.392z",
      fill: "#D52C1E"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.224 11.076l.133.42.27-.115s.405 1.896 0 2.69c-.403.795-1.422.853-1.422.853l.43-3.429.588-.419z",
      fill: "#027934"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.283 13.639l.97.767s.267.382 0 .67c-.265.29-1.003.584-1.178.235-.174-.348-.69-.757-.69-.757l.898-.915z",
      fill: "#E8A30C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.521 10.742c-.236-.205-.354-.456-.264-.56.09-.103.355-.02.59.185.237.205.355.455.265.559-.09.104-.354.021-.59-.184z",
      fill: "#E1E5E8"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.03 15.378l.509-.005c.378.374.412.877.115 1.484 0 0-.098.141-.132.128-.048-.018-.114-.223-.114-.223.022-.593-.356-.986-.378-1.384z",
      fill: "#D52C1E"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.674 15.394l-.183-.085c-.18.374-.09.763.258 1.148l.151-.132c-.151-.442-.151-.625-.226-.931z",
      fill: "#FFE000"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M16.907 15.382l-.19-.056c-.092.314-.046.638.134.966l.174-.095c-.156-.284-.194-.554-.117-.815z",
      fill: "#027934"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.553 12.82c0 1.44 1.062 2.637 2.42 2.637 1.358 0 2.42-1.197 2.42-2.637 0-1.439-1.062-2.636-2.42-2.636-1.358 0-2.42 1.197-2.42 2.636zm4.274 0c0 1.154-.83 2.09-1.854 2.09s-1.854-.936-1.854-2.09.83-2.09 1.854-2.09 1.854.936 1.854 2.09z",
      fill: "#00A6DE"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.973 14.91c1.024 0 1.854-.936 1.854-2.09s-.83-2.09-1.854-2.09-1.854.936-1.854 2.09.83 2.09 1.854 2.09z",
      fill: "#FFC036"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "BO_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 14,
      y: 10,
      width: 4,
      height: 5
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.973 14.91c1.024 0 1.854-.936 1.854-2.09s-.83-2.09-1.854-2.09-1.854.936-1.854 2.09.83 2.09 1.854 2.09z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#BO_svg__c)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M15.974 12.447l-.24.496.005-.548-.44.347.252-.492-.551.128.447-.337-.554-.116.554-.117-.447-.337.551.128-.251-.491.44.346-.007-.548.241.496.24-.496-.005.548.44-.346-.252.491.552-.128-.448.337.555.117-.555.116.448.337-.552-.128.252.492-.44-.347.006.548-.24-.496z",
      fill: "#D52C1E"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.04 12.94s1.45-1.021 1.806-1.021c.356 0 1.876 1.026 2.187 1.166.31.14 0 2.878 0 2.878H13.92l.12-3.023z",
      fill: "#027934"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.03 11.726l.088.05c.49-.825 1.11-1.234 1.869-1.234.849.047 1.485.51 1.909 1.396l.093-.041c-.44-.918-1.107-1.405-2-1.455-.8 0-1.454.43-1.96 1.284zm-.36 1.59l.166-.112.166.112-.058-.187.161-.119-.203-.004-.066-.185-.067.185-.203.004.162.119-.059.187zm.37.634l-.166.112.06-.187-.162-.118.202-.005.067-.185.066.185.203.005-.161.118.058.187-.166-.111zm.247.71l.166-.113.167.112-.06-.188.162-.118-.202-.004-.067-.185-.067.185-.202.004.161.119-.059.187zm.785.385l-.166.112.058-.187-.161-.119.202-.004.067-.185.067.185.203.004-.162.119.059.187-.167-.112zm.709.36l.166-.112.167.112-.06-.187.163-.119-.203-.004-.067-.185-.066.185-.203.004.161.119-.058.187zm2.33-2.2l.167.111-.06-.187.163-.119-.203-.004-.067-.185-.067.185-.202.004.161.119-.058.187.166-.112zm-.04.857l-.167-.111-.166.111.058-.187-.161-.118.202-.005.067-.185.067.185.202.005-.161.118.058.187zm-.58.485l.167.112-.058-.188.161-.118-.203-.004-.066-.185-.067.185-.203.004.162.119-.059.187.167-.112zm-.45.61l-.166-.112-.167.112.059-.187-.162-.119.203-.004.067-.185.066.185.203.004-.161.119.058.187z",
      fill: "#FFC036"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M14.683 7.007l.199.144c-.51.458-.605.967-.508 1.405.102.456.553.943 1.375 1.443l-.302.463c-.938-.57-1.478-1.099-1.618-1.728-.144-.647.21-1.149.854-1.727zM17.387 7.007l-.198.144c.509.458.605.967.507 1.405-.101.456-.553.943-1.374 1.443l.302.463c.937-.57 1.477-1.099 1.617-1.728.145-.647-.21-1.149-.854-1.727z",
      fill: "#036A2D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.776 8.861s.869-.6 1.281-.6c.413 0 .964-.138 1.05.178.086.316.25.225.569.225h.947s-.187-.404.16-.404c.348 0 1.8.206 2.237.404.439.197.46.314.46.314s-.405-.234-.853-.117c-.449.117-1.262.632-1.633.632-.37 0-.667.399-.667.399s.024-.204-.313-.102c-.338.102-.33.582-.618.494-.289-.088.083-.79 0-.79-.084 0-.673-.231-.673-.231s-.571-.519-1.42-.402c-.848.117-.527 0-.527 0z",
      fill: "#452C24"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.871 9.288c.171 0 .31-.122.31-.273 0-.151-.139-.274-.31-.274-.17 0-.309.123-.309.274 0 .151.139.273.31.273z",
      fill: "#E7E7E7"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.205 9.007s.1-.189.298-.189c.198 0 .57 0 .57.095 0 .094.03.218-.27.218-.3 0-.108-.124-.3-.124h-.298z",
      fill: "#E8A30C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.737 10.283c.115-.12.18-.413.18-.413s-.515.083-.634 0c-.12-.082-.182-.323-.182-.323s-.463.212-.287.212c.177 0 .287.156.287.156l.36.133s-.24.235-.12.235.281.12.396 0z",
      fill: "#E1E5E8"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M17.83 10.384l-.064-.077.451-.354.065.078-.452.353z",
      fill: "#925229"
    }
  )))
);
export {
  d as default
};
